module.exports = __webpack_public_path__ + "media/images/s02_01_pt-20e0acd53a88987f4769b986b2bdce15.svg";